// PROGRAM: Background — Procedural flag background, product image swap
// Split from retro-utilities.js

(function() {
    'use strict';

    var Background = {
        init: function() {
            this.generateFlagBackground();
        },

        generateFlagBackground: function() {
            var flags = "🇺🇳🇺🇸🇬🇧🇨🇦🇫🇷🇩🇪🇮🇹🇯🇵🇦🇺🇳🇿🇪🇸🇵🇹🇳🇱🇧🇪🇩🇰🇸🇪🇳🇴🇫🇮🇮🇪🇨🇭🇦🇹🇬🇷🇰🇷🇸🇬🇹🇷🇧🇷🇲🇽🇦🇷🇨🇱🇿🇦🇸🇦🇦🇪🇶🇦🇰🇼🇧🇭🇴🇲";
            var flagsRepeated = '';
            for (var i = 0; i < 10; i++) { flagsRepeated += flags; }

            var svgString = '<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512">' +
                '<foreignObject width="100%" height="100%">' +
                '<div xmlns="http://www.w3.org/1999/xhtml" style="font-size: 32px; line-height: 1; font-family: \'Apple Color Emoji\', \'Segoe UI Emoji\', \'Noto Color Emoji\', serif; opacity: 0.1; word-wrap: break-word; overflow: hidden; height: 100%;">' +
                flagsRepeated +
                '</div></foreignObject></svg>';

            var encodedSvg = window.btoa(unescape(encodeURIComponent(svgString)));
            document.body.style.backgroundImage = 'url("data:image/svg+xml;base64,' + encodedSvg + '")';
        }
    };

    // Register with PROGRAMS if available
    if (window.PROGRAMS && window.PROGRAMS.register) {
        window.PROGRAMS.register('Background', Background);
    }

    // Always generate flags immediately — don't wait for PROGRAMS init
    Background.generateFlagBackground();

    // Global function for inline onclick handler in product thumbnails
    window.swapProductImage = function(url) {
        var mainImg = document.getElementById('main-product-image');
        if (mainImg) mainImg.src = url;
    };

})();
